import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-flashlight-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">
                棒棒<span className="text-primary-400">TV</span>
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              在线不缓冲秒播，即点即看零等待。免费高清视频流畅播放，电视剧全集电影大全，为亿万用户提供极致的观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="/about#faq" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">
                  常见问题
                </a>
              </li>
              <li>
                <a href="/about#contact" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@bangbangtv.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>棒棒TV官方</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 棒棒TV. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}